export default "/images/fbc9abd1569f3f930f8ba7a2b2a5c44b.avif";